import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    ano,
} from '../../../business-components/Date/Date'

import {
    round
} from '../../../business-components/round/round'

import {
    pesquisaList,
    pesquisaDescricaoList,
} from '../../../business-rules/List/ListService'

import tipoDiaDiaList from '../../../business-rules/List/tipoDiaDiaList'

//import parentescoList from '../../../business-rules/List/parentescoList'

import {
    calculaValorPerc,
} from '../cliente-form/ClienteService'

import {
    familiarPossuiReceitaMensal,
    calculaReceitaMensalFamiliarTipoReceitaMensal,
} from '../garantias-form/GarantiasServiceReceitaMensal'

import {
    calculaValorCS,
} from '../seguroVida-form/SeguroVidaService'

import {
    formataTempoCobertura,
} from './EstudoService'

import {
    processaCalculoEstudo
} from './EstudoServiceCalculo'



const adicionaProtecaoSugerida = (values, idFamiliar, protecaoSugerida, descricao, valorApolices, valorCS,
    anosProteger, detalhamento) => {

    const descricaoPesquisa = descricao + '-' + idFamiliar
    const anosProtegerFormatado =
        anosProteger || anosProteger === 0
            ?
                anosProteger === HARDCODE.tempoCoberturaDITDITA
                    ?
                        HARDCODE.tempoCoberturaDITDITA
                    :
                        formataTempoCobertura(anosProteger)
            :
                ''

    let protecaoSugeridaAux = {
        descricao: descricao,
        descricaoTrim: descricao.trim(),
        descricaoPesquisa: descricaoPesquisa,
        valorNecessidade1: '',
        valorApolices1: '',
        valorCS1: '',
        tempoCoberturaSeguroVida1: '',
        valorNecessidade2: '',
        valorApolices2: '',
        valorCS2: '',
        tempoCoberturaSeguroVida2: '',
        detalhamento: detalhamento,
    }

    let indexProtecaoSugerida = ''

    protecaoSugerida?.forEach( (linhaProtecaoSugerida, index) => {

        if (linhaProtecaoSugerida.descricaoPesquisa === descricaoPesquisa) {

            protecaoSugeridaAux = linhaProtecaoSugerida
            indexProtecaoSugerida = index
        }
    })

    if (!indexProtecaoSugerida && indexProtecaoSugerida !== 0) {

        protecaoSugerida.push(protecaoSugeridaAux)
    }
    
    if (
            values.morteInvalidezEstudo === HARDCODE.morteInvalidezEstudoMorteAte ||
            values.morteInvalidezEstudo === HARDCODE.morteInvalidezEstudoInvalidez || 
            descricao === LABEL.funeral
    ) {

        protecaoSugeridaAux.valorNecessidade1 = valorApolices !== null ? valorCS + valorApolices : ''
        protecaoSugeridaAux.valorApolices1 = valorApolices ? valorApolices : valorApolices === 0 ? LABEL.tracoXtraco : ''
        protecaoSugeridaAux.valorCS1 = valorCS
        
        protecaoSugeridaAux.tempoCoberturaSeguroVida1 = anosProtegerFormatado
    }

    if (
            values.morteInvalidezEstudo === HARDCODE.morteInvalidezEstudoMorte ||
            values.morteInvalidezEstudo === HARDCODE.morteInvalidezEstudoInvalidez ||
            descricao === LABEL.funeral
    ) {

        protecaoSugeridaAux.valorNecessidade2 =  valorApolices !== null ? valorCS + valorApolices : ''
        protecaoSugeridaAux.valorApolices2 = valorApolices ? valorApolices : valorApolices === 0 ? LABEL.tracoXtraco : ''
        protecaoSugeridaAux.valorCS2 = valorCS
        
        protecaoSugeridaAux.tempoCoberturaSeguroVida2 = anosProtegerFormatado
    }

    protecaoSugerida?.forEach( (linhaProtecaoSugerida, index) => {

        if (linhaProtecaoSugerida.descricaoPesquisa === descricaoPesquisa) {
            protecaoSugerida[index] = protecaoSugeridaAux
        }
    })
}

const calculaMorteSucessaoVitalicia = (values, idFamiliar, sucessaoVitalicia, protecaoSugerida) => {

    const valorCSVidaInteira = 
        idFamiliar === HARDCODE.idFamiliarCliente
            ?
                values.valorCSVidaInteiraApoliceCliente
            :
                values.valorCSVidaInteiraApoliceConjuge

    const valorPrevidenciaPrivada =
        values.utilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia
            ?
                idFamiliar === HARDCODE.idFamiliarCliente
                    ?
                        values.valorPrevidenciaPrivadaCliente
                    :
                        values.valorPrevidenciaPrivadaConjuge
            :
                0

    let morteSucessaoVitalicia

    //if (valorCSVidaInteira + valorPrevidenciaPrivada <= sucessaoVitalicia) {
        morteSucessaoVitalicia = sucessaoVitalicia - valorCSVidaInteira - valorPrevidenciaPrivada
    //} else {
    //    morteSucessaoVitalicia = 0
    //}

    //if (morteSucessaoVitalicia > 0 && !values.naoExibirMorteSucessaoVitalicia) {
    if ((morteSucessaoVitalicia > 0 || valorCSVidaInteira > 0) && !values.naoExibirMorteSucessaoVitalicia) {
        
        adicionaProtecaoSugerida(values, idFamiliar, protecaoSugerida, LABEL.perpetuarPatrimonio, valorCSVidaInteira,
            morteSucessaoVitalicia, LABEL.vitalicio, "N")
    }

    //return morteSucessaoVitalicia
}

const calculaNecessidadeDependente = (values, estudo, idFamiliar, protecaoSugerida) => {

    let valorTotalCSDependente = 0

    const diaDiaDespesasVitaliciasTemporarias = [
        ...estudo.current.diaDiaDespesasVitalicias,
        ...estudo.current.diaDiaDespesasTemporarias,
    ]

    diaDiaDespesasVitaliciasTemporarias?.forEach( (linhaDiaDiaDespesasVitaliciasTemporarias, index) => {

        if (
                //linhaDiaDiaDespesasVitaliciasTemporarias.familiar === idFamiliar &&
                linhaDiaDiaDespesasVitaliciasTemporarias.valorAcumuladoDependente
        ) {
            const linhaDiaDia = pesquisaList(values.diaDia, linhaDiaDiaDespesasVitaliciasTemporarias.id) 

            const valorCSDependente = round(linhaDiaDiaDespesasVitaliciasTemporarias.valorAcumuladoDependente, 2)

            adicionaProtecaoSugerida(values, linhaDiaDiaDespesasVitaliciasTemporarias.familiar, protecaoSugerida,
                espacoDetalhamento + pesquisaDescricaoList(tipoDiaDiaList, linhaDiaDia.tipoDiaDia) +
                    (linhaDiaDia.descricaoDiversasOutros ? " - " + linhaDiaDia.descricaoDiversasOutros : '')/* +
                        //" - " + pesquisaDescricaoList(parentescoList(false), linhaDiaDia.parentescoDependente) +
                            (linhaDiaDia.observacao ? " - " + linhaDiaDia.observacao : "")*/, null, valorCSDependente,
                                linhaDiaDiaDespesasVitaliciasTemporarias.anoFinal -
                                    ano(values.dataSimulacaoEstudo) + 1, "S")

            valorTotalCSDependente += valorCSDependente
        }
    })

    return valorTotalCSDependente
}

const espacoDetalhamento = "      "

const calculaMorteTemporaria = (values, estudo, idFamiliar, morteSucessaoVitalicia, necessidadeProtecao,
    protecaoSugerida, valorApolicesMorte, valorCSVidaInteira, valorCSEducacao, valorCSFinanciamento, valorCSProjetoVidaSonho) => {


    //if (morteSucessaoVitalicia <= necessidadeProtecao) {

        //let valorCSMorteTemporaria = necessidadeProtecao - morteSucessaoVitalicia
    
    let valorCSMorteTemporaria = necessidadeProtecao - morteSucessaoVitalicia

    const valorApolicesMorteTemporaria = valorApolicesMorte - valorCSVidaInteira
    
    if (valorCSMorteTemporaria > 0 || valorApolicesMorteTemporaria > 0) {

        adicionaProtecaoSugerida(values, idFamiliar, protecaoSugerida, LABEL.proporcionarConfortoFamilia,
            valorApolicesMorteTemporaria, valorCSMorteTemporaria, null, "N")

        if (morteSucessaoVitalicia <= necessidadeProtecao) {

            if (valorCSEducacao > 0) {

                estudo.current.educacao.forEach( (linhaEstudoEducacao, index) => {

                    if (linhaEstudoEducacao.tipo === "S") {

                        if (idFamiliar === HARDCODE.idFamiliarCliente) {

                            valorCSEducacao = linhaEstudoEducacao.valorDespesaCliente
                        } else {

                            valorCSEducacao = linhaEstudoEducacao.valorDespesaConjuge
                        }

                        if (valorCSEducacao > 0) {

                            if (valorCSEducacao > valorCSMorteTemporaria) {
                                valorCSEducacao = valorCSMorteTemporaria
                            }

                            if (valorCSEducacao > 0) {
                                adicionaProtecaoSugerida(values, linhaEstudoEducacao.familiar, protecaoSugerida,
                                    espacoDetalhamento + LABEL.educacao + ": " + linhaEstudoEducacao.nomeCurtoFamiliar,
                                        null, valorCSEducacao, linhaEstudoEducacao.anosProtegerProtegido, "S")

                                valorCSMorteTemporaria = round(valorCSMorteTemporaria - valorCSEducacao, 2)
                            }
                        }
                    }
                })
            }



            valorCSMorteTemporaria -= calculaNecessidadeDependente(values, estudo, idFamiliar, protecaoSugerida)



            if (valorCSMorteTemporaria > 0) {

                if (valorCSFinanciamento > 0) {
                    if (valorCSFinanciamento > valorCSMorteTemporaria) {
                        valorCSFinanciamento = valorCSMorteTemporaria
                    }

                    adicionaProtecaoSugerida(values, idFamiliar, protecaoSugerida,
                        espacoDetalhamento + LABEL.financiamento, null, valorCSFinanciamento,
                            estudo.current.panelDespesasTotais[HARDCODE.indexEstudoFinanciamento].anosProtegerProtegido, "S")

                    valorCSMorteTemporaria = round(valorCSMorteTemporaria - valorCSFinanciamento, 2)
                }
            }



            if (valorCSMorteTemporaria > 0) {

                if (valorCSProjetoVidaSonho > 0) {
                    if (valorCSProjetoVidaSonho > valorCSMorteTemporaria) {
                        valorCSProjetoVidaSonho = valorCSMorteTemporaria
                    }

                    adicionaProtecaoSugerida(values, idFamiliar, protecaoSugerida,
                        espacoDetalhamento + LABEL.projetoVidaSonho, null, valorCSProjetoVidaSonho,
                            estudo.current.panelDespesasTotais[HARDCODE.indexEstudoProjetoVidaSonho].anosProtegerProtegido, "S")

                    valorCSMorteTemporaria = round(valorCSMorteTemporaria - valorCSProjetoVidaSonho, 2)
                }
            }



            if (valorCSMorteTemporaria > 0) {

                adicionaProtecaoSugerida(values, idFamiliar, protecaoSugerida, espacoDetalhamento +LABEL.diaDia,
                    null, valorCSMorteTemporaria, 
                        estudo.current.panelDespesasTotais[HARDCODE.indexEstudoDiaDia].anosProtegerProtegido, "S")
            }
        }

    } else {
        
        adicionaProtecaoSugerida(values, idFamiliar, protecaoSugerida, LABEL.proporcionarConfortoFamilia, null, 0, null, "N")

        calculaNecessidadeDependente(values, estudo, idFamiliar, protecaoSugerida)
    }
}

//const calculaDITDITAValorCS = ( values, valorCSMensalDespesa, idFamiliar ) => {

//    let valorCSDITDITA =
//        valorCSMensalDespesa -
//            calculaReceitaMensalFamiliarTipoReceitaMensal(values, idFamiliar, 
//                HARDCODE.idTipoReceitaMensalInssRendaInvalidez) -
//                    calculaReceitaMensalFamiliarTipoReceitaMensal(values, idFamiliar,
//                        HARDCODE.idTipoReceitaMensalPensaoRendaInvalidez) -
//                            calculaValorCS(values, idFamiliar, null, HARDCODE.idTipoCoberturaSeguroVidaDIT) -
//                                calculaValorCS(values, idFamiliar, null, HARDCODE.idTipoCoberturaSeguroVidaSERIT) -
//                                    calculaValorCS(values, idFamiliar, null, HARDCODE.idTipoCoberturaSeguroVidaDITA)

//    if (valorCSDITDITA < 0) {
//        valorCSDITDITA = 0
//    }

//    return valorCSDITDITA
//}

const calculaDITDITA = ( values, jsonConfiguracao, protecaoSugerida, valorCSMensalDespesa, idFamiliar ) => {

    const valorApolicesDITDITA = calculaValorCS(values, idFamiliar, null, HARDCODE.idTipoCoberturaSeguroVidaDIT) -
        calculaValorCS(values, idFamiliar, null, HARDCODE.idTipoCoberturaSeguroVidaSERIT) -
            calculaValorCS(values, idFamiliar, null, HARDCODE.idTipoCoberturaSeguroVidaDITA)

    const valorCSDITDITA =
        valorCSMensalDespesa -
            calculaReceitaMensalFamiliarTipoReceitaMensal(values, idFamiliar, 
                HARDCODE.idTipoReceitaMensalInssRendaInvalidez) -
                    calculaReceitaMensalFamiliarTipoReceitaMensal(values, idFamiliar,
                        HARDCODE.idTipoReceitaMensalPensaoRendaInvalidez) -
                            calculaReceitaMensalFamiliarTipoReceitaMensal(values, null,
                                HARDCODE.idTipoReceitaMensalAluguel) - valorApolicesDITDITA

    if (
            familiarPossuiReceitaMensal(values, idFamiliar, HARDCODE.idTipoReceitaMensalProfissionalLiberal) ||
            familiarPossuiReceitaMensal(values, idFamiliar, HARDCODE.idTipoReceitaMensalProlabore)
    ) {

        //const valorCSDIT = calculaDITDITAValorCS(values, valorCSMensalDespesa, idFamiliar)

        //if (valorCSDIT > 0) {
        if (valorCSDITDITA > 0 || valorApolicesDITDITA > 0) {

            adicionaProtecaoSugerida(values, idFamiliar, protecaoSugerida, espacoDetalhamento +
                (jsonConfiguracao && jsonConfiguracao.textoCoberturaSugeridaDITDITA
                    ?
                        jsonConfiguracao.textoCoberturaSugeridaDITDITA
                    :
                        LABEL.DIT
                ),
                    valorApolicesDITDITA, valorCSDITDITA/*valorCSDIT*/, HARDCODE.tempoCoberturaDITDITA, "S")
        }
            
    } else {

        if (familiarPossuiReceitaMensal(values, idFamiliar, HARDCODE.idTipoReceitaMensalCLT)) {

            //const valorCSDITA = calculaDITDITAValorCS(values, valorCSMensalDespesa, idFamiliar)

            //if (valorCSDITA > 0) {
            if (valorCSDITDITA > 0 || valorApolicesDITDITA > 0) {

                adicionaProtecaoSugerida(values, idFamiliar, protecaoSugerida, espacoDetalhamento +
                    (jsonConfiguracao && jsonConfiguracao.textoCoberturaSugeridaDITDITA
                        ?
                            jsonConfiguracao.textoCoberturaSugeridaDITDITA
                        :
                            LABEL.DITA
                    ),
                        valorApolicesDITDITA, valorCSDITDITA/*valorCSDITA*/, HARDCODE.tempoCoberturaDITDITA, "S")
            }
        }
    }
}

const calculaDoencasGraves = ( values, jsonConfiguracao, protecaoSugerida, valorCSMensalDespesa, valorCSMensalReceita, idFamiliar ) => {

    let mesesSugestaoDoencasGraves = HARDCODE.mesesSugestaoDoencasGraves
    let tipoCalculoSugestaoDoencasGraves = HARDCODE.idTipoCalculoSugestaoDoencasGravesDespesa
    let valorCSMensal
    let anosProteger

    if (values.mesesSugestaoDoencasGraves || values.mesesSugestaoDoencasGraves === 0) {

        mesesSugestaoDoencasGraves = values.mesesSugestaoDoencasGraves

    } else {

        if (jsonConfiguracao && jsonConfiguracao.mesesSugestaoDoencasGraves) {

            mesesSugestaoDoencasGraves = jsonConfiguracao.mesesSugestaoDoencasGraves
        }
    }

    if (values.tipoCalculoSugestaoDoencasGraves) {

        tipoCalculoSugestaoDoencasGraves = values.tipoCalculoSugestaoDoencasGraves

    } else {

        if (jsonConfiguracao && jsonConfiguracao.tipoCalculoSugestaoDoencasGraves) {

            tipoCalculoSugestaoDoencasGraves = jsonConfiguracao.tipoCalculoSugestaoDoencasGraves
        }
    }

    if (tipoCalculoSugestaoDoencasGraves ===  HARDCODE.idTipoCalculoSugestaoDoencasGravesDespesa) {

        valorCSMensal = valorCSMensalDespesa

    } else {

        valorCSMensal = valorCSMensalReceita
    }

    valorCSMensal -= calculaReceitaMensalFamiliarTipoReceitaMensal(values, null, HARDCODE.idTipoReceitaMensalAluguel)

    if (valorCSMensal > 0 || values.despesasAdicionaisDoencasGravesCliente || values.despesasAdicionaisDoencasGravesConjuge) {

        anosProteger = mesesSugestaoDoencasGraves / 12

        const valorApolicesDoencasGraves =
            calculaValorCS(values, idFamiliar, null, HARDCODE.idTipoCoberturaSeguroVidaDoencasGraves) +
                calculaValorCS(values, idFamiliar, null, HARDCODE.idTipoCoberturaSeguroVidaEmGrupoDoencasGraves)

        const valorCSDoencasGraves =
            (valorCSMensal > 0 ? valorCSMensal * mesesSugestaoDoencasGraves : 0)
                + (values.despesasAdicionaisDoencasGravesCliente && idFamiliar === HARDCODE.idFamiliarCliente
                    ? round(values.despesasAdicionaisDoencasGravesCliente, 2) : 0)
                        + (values.despesasAdicionaisDoencasGravesConjuge && idFamiliar === HARDCODE.idFamiliarConjuge
                            ? round(values.despesasAdicionaisDoencasGravesConjuge, 2) : 0)
                                - valorApolicesDoencasGraves

        //if (valorCSDoencasGraves > 0) {
        if (valorCSDoencasGraves > 0 || valorApolicesDoencasGraves > 0) {

            adicionaProtecaoSugerida(values, idFamiliar, protecaoSugerida, espacoDetalhamento + LABEL.doencasGraves,
                valorApolicesDoencasGraves, valorCSDoencasGraves, anosProteger, "S")
        }
    }
}

const excluiLinhaIncapacidadeQuandoNaoTemSubitem = ( protecaoSugerida ) => {

    const index = protecaoSugerida.length - 1

    if (protecaoSugerida[index].descricaoTrim === LABEL.protecaoEmVida) {
        
        protecaoSugerida.splice(index, 1)
    }
}

const calculaProtecaoSugeridaMorte = ( values, estudo, jsonConfiguracao ) => {

    /*let morteSucessaoVitalicia = */calculaMorteSucessaoVitalicia(values,
        HARDCODE.idFamiliarCliente, values.sucessaoVitaliciaCliente, values.protecaoSugeridaCliente)

    //values.morteSucessaoVitaliciaCliente = morteSucessaoVitalicia

    calculaMorteTemporaria(values, estudo, HARDCODE.idFamiliarCliente, values.sucessaoVitaliciaCliente/*morteSucessaoVitalicia*/,
        values.necessidadeProtecaoClienteCalculoMorte/*values.necessidadeProtecaoCliente*/, values.protecaoSugeridaCliente,
            estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoSeguroVida].valorReceitaClientePainel,
                values.valorCSVidaInteiraApoliceCliente,
                    estudo.current.panelDespesasTotais[HARDCODE.indexEstudoEducacao].valorDespesaClientePainel,
                        estudo.current.panelDespesasTotais[HARDCODE.indexEstudoFinanciamento].valorDespesaClientePainel,
                            estudo.current.panelDespesasTotais[HARDCODE.indexEstudoProjetoVidaSonho].valorDespesaClientePainel)
        



    /*morteSucessaoVitalicia = */calculaMorteSucessaoVitalicia(values, HARDCODE.idFamiliarConjuge,
        values.sucessaoVitaliciaConjuge, values.protecaoSugeridaConjuge)

    //values.morteSucessaoVitaliciaConjuge = morteSucessaoVitalicia
    
    calculaMorteTemporaria(values, estudo, HARDCODE.idFamiliarConjuge, values.sucessaoVitaliciaConjuge/*morteSucessaoVitalicia*/,
        values.necessidadeProtecaoConjugeCalculoMorte/*values.necessidadeProtecaoConjuge*/, values.protecaoSugeridaConjuge,
            estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoSeguroVida].valorReceitaConjugePainel,
                values.valorCSVidaInteiraApoliceConjuge,
                    estudo.current.panelDespesasTotais[HARDCODE.indexEstudoEducacao].valorDespesaConjugePainel,
                        estudo.current.panelDespesasTotais[HARDCODE.indexEstudoFinanciamento].valorDespesaConjugePainel,
                            estudo.current.panelDespesasTotais[HARDCODE.indexEstudoProjetoVidaSonho].valorDespesaConjugePainel)

    

    //const despesaMensal = round(estudo.current.graficoDespesaAnualTotalMedia[0] / (12 - mes(values.dataSimulacaoEstudo) + 1), 2)
    //const receitaMensal = round(estudo.current.graficoReceitaAnualTotalMedia[0] / (12 - mes(values.dataSimulacaoEstudo) + 1), 2)

    if (!values.naoExibirInvalidez || !values.naoExibirDITDITA || !values.naoExibirDoencasGraves) {

        adicionaProtecaoSugerida(values, HARDCODE.idFamiliarCliente, values.protecaoSugeridaCliente,
            LABEL.protecaoEmVida, null, null, null, "N")
    }

    if (!values.naoExibirDITDITA) {

        calculaDITDITA(values, jsonConfiguracao, values.protecaoSugeridaCliente,
            calculaValorPerc(values.despesaMensalMediaAtual, values.percRespCliente),
                HARDCODE.idFamiliarCliente)
    }

    if (!values.naoExibirDoencasGraves) {

        calculaDoencasGraves(values, jsonConfiguracao, values.protecaoSugeridaCliente,
            calculaValorPerc(values.despesaMensalMediaAtual, values.percRespCliente),
                calculaValorPerc(values.receitaMensalMediaAtual, values.percRespCliente),
                    HARDCODE.idFamiliarCliente)
    }

    if (!values.naoExibirInvalidez || !values.naoExibirDITDITA || !values.naoExibirDoencasGraves) {

        adicionaProtecaoSugerida(values, HARDCODE.idFamiliarConjuge, values.protecaoSugeridaConjuge,
            LABEL.protecaoEmVida, null, null, null, "N")
    }

    if (!values.naoExibirDITDITA) {
    
        calculaDITDITA(values, jsonConfiguracao, values.protecaoSugeridaConjuge,
            values.despesaMensalMediaAtual - calculaValorPerc(values.despesaMensalMediaAtual,
                values.percRespCliente), HARDCODE.idFamiliarConjuge)
    }
    
    if (!values.naoExibirDoencasGraves) {
    
        calculaDoencasGraves(values, jsonConfiguracao, values.protecaoSugeridaConjuge,
            values.despesaMensalMediaAtual - calculaValorPerc(values.despesaMensalMediaAtual, values.percRespCliente),
                values.receitaMensalMediaAtual - calculaValorPerc(values.receitaMensalMediaAtual, values.percRespCliente),
                    HARDCODE.idFamiliarConjuge)
    }
}

const calculaInvalidez = ( values, idFamiliar, estudo, jsonConfiguracao, necessidadeProtecao,
    protecaoSugerida, valorApolicesInvalidez ) => {

    if (necessidadeProtecao > 0 || valorApolicesInvalidez) {

        adicionaProtecaoSugerida(values, idFamiliar, protecaoSugerida,
            espacoDetalhamento + (jsonConfiguracao && jsonConfiguracao.textoCoberturaSugeridaInvalidez
                ?
                    jsonConfiguracao.textoCoberturaSugeridaInvalidez
                :
                    LABEL.invalidez
            ),
                valorApolicesInvalidez, necessidadeProtecao,
                    estudo.current.panelDespesasTotais[HARDCODE.indexEstudoDiaDia].anosProtegerProtegido, "S")
    }
}

const calculaProtecaoSugeridaInvalidez = ( values, estudo, jsonConfiguracao ) => {

    calculaInvalidez(values, HARDCODE.idFamiliarCliente, estudo, jsonConfiguracao,
        values.necessidadeProtecaoClienteCalculoInvalidez/*values.necessidadeProtecaoCliente*/ - values.sucessaoVitaliciaCliente/* +
            (values.utilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia
                ?
                    values.valorPrevidenciaPrivadaCliente
                :
                    0
            )*/, values.protecaoSugeridaCliente,
                estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoSeguroVida].valorReceitaClientePainel)

    excluiLinhaIncapacidadeQuandoNaoTemSubitem(values.protecaoSugeridaCliente)

    calculaInvalidez(values, HARDCODE.idFamiliarConjuge, estudo, jsonConfiguracao,
        values.necessidadeProtecaoConjugeCalculoInvalidez/*values.necessidadeProtecaoConjuge*/ - values.sucessaoVitaliciaConjuge/* +
            (values.utilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia
                ?
                    values.valorPrevidenciaPrivadaConjuge
                :
                    0
            )*/, values.protecaoSugeridaConjuge,
                estudo.current.panelGarantiasAtuais[HARDCODE.indexEstudoSeguroVida].valorReceitaConjugePainel)

    excluiLinhaIncapacidadeQuandoNaoTemSubitem(values.protecaoSugeridaConjuge)
}

const calculaFuneral = ( values, idFamiliar, protecaoSugerida ) => {

    const valorApolicesFuneral = calculaValorCS(values, idFamiliar, HARDCODE.idGrupoCoberturaSeguroVidaFuneral, null)

    const valorCSFuneral = (values.funeral ? round(values.funeral, 2) : HARDCODE.valorSugestaoFuneral) -
        valorApolicesFuneral

    //if (calculaValorCS(values, idFamiliar, HARDCODE.idGrupoCoberturaSeguroVidaFuneral, null) === 0) {
    if (valorCSFuneral > 0 || valorApolicesFuneral > 0) {

        adicionaProtecaoSugerida(values, idFamiliar, protecaoSugerida, LABEL.funeral, valorApolicesFuneral,
            valorCSFuneral, HARDCODE.tempoCoberturaFuneral, "N")
    }
}

const calculaProtecaoSugerida = ( values, handleSubmitAutomatico, estudo, jsonConfiguracao, report ) => {

    values.protecaoSugeridaCliente = []

    values.protecaoSugeridaConjuge = []

    const morteInvalidezEstudoAnt = values.morteInvalidezEstudo

    let processouCalculo = false


    if (!values.naoExibirMorteVitalicia) {

        if (
                /*values.morteInvalidezEstudo !== HARDCODE.morteInvalidezEstudoMorteAte && */
                values.morteInvalidezEstudo !== HARDCODE.morteInvalidezEstudoMorte
        ) {
        
            values.morteInvalidezEstudo = HARDCODE.morteInvalidezEstudoMorte

            processaCalculoEstudo(values, handleSubmitAutomatico, estudo, report, true,
                HARDCODE.origemCalculoEstudoEstudo, false, jsonConfiguracao, false)

            processouCalculo = true
        }

        calculaProtecaoSugeridaMorte(values, estudo, jsonConfiguracao)
    }



    //if (values.morteInvalidezEstudo === HARDCODE.morteInvalidezEstudoMorteAte) {

    //    values.morteInvalidezEstudo = HARDCODE.morteInvalidezEstudoMorte

    //} else {

    if (values.exibirMorteAte) {

        values.morteInvalidezEstudo = HARDCODE.morteInvalidezEstudoMorteAte
    //}

        processaCalculoEstudo(values, handleSubmitAutomatico, estudo, report, true,
            HARDCODE.origemCalculoEstudoEstudo, false, jsonConfiguracao, false)
        
        processouCalculo = true
        
        calculaProtecaoSugeridaMorte(values, estudo, jsonConfiguracao)
    }



    if (!values.naoExibirInvalidez) {

        values.morteInvalidezEstudo = HARDCODE.morteInvalidezEstudoInvalidez

        processaCalculoEstudo(values, handleSubmitAutomatico, estudo, report, true,
            HARDCODE.origemCalculoEstudoEstudo, false, jsonConfiguracao, false)
        
        processouCalculo = true

        calculaProtecaoSugeridaInvalidez(values, estudo, jsonConfiguracao)
    }
    


    if (values.morteInvalidezEstudo !== morteInvalidezEstudoAnt || processouCalculo) {
        
        values.morteInvalidezEstudo = morteInvalidezEstudoAnt

        processaCalculoEstudo(values, handleSubmitAutomatico, estudo, report, true,
            report ? HARDCODE.origemCalculoEstudoEstudoReport : HARDCODE.origemCalculoEstudoEstudo,
                false, jsonConfiguracao, true)
    }

    
    
    if (!values.naoExibirFuneral) {

        calculaFuneral(values, HARDCODE.idFamiliarCliente, values.protecaoSugeridaCliente)

        calculaFuneral(values, HARDCODE.idFamiliarConjuge, values.protecaoSugeridaConjuge)
    }
}

export const processaValoresDefaultIniciaisProtecaoSugeridaClienteConjuge = ( values, handleSubmitAutomatico, estudo,
    jsonConfiguracao, report ) => {

    calculaProtecaoSugerida(values, handleSubmitAutomatico, estudo, jsonConfiguracao, report)
}